import { render, staticRenderFns } from "./FundDetailView.vue?vue&type=template&id=5e56592e&scoped=true&"
import script from "./FundDetailView.vue?vue&type=script&lang=js&"
export * from "./FundDetailView.vue?vue&type=script&lang=js&"
import style0 from "./FundDetailView.vue?vue&type=style&index=0&id=5e56592e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e56592e",
  null
  
)

export default component.exports